const ErrorFill: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Action/error-fill">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47714 6.47715 1.99999 12 1.99999C17.5229 1.99999 22 6.47714 22 12C22 17.5228 17.5229 22 12 22ZM11.2063 7.23809C11.2063 6.79977 11.5617 6.44444 12 6.44444C12.4383 6.44444 12.7936 6.79977 12.7936 7.23809V12.7936C12.7936 13.232 12.4383 13.5873 12 13.5873C11.5617 13.5873 11.2063 13.232 11.2063 12.7936V7.23809ZM13.1905 16.3651C13.1905 15.7076 12.6575 15.1746 12 15.1746C11.3425 15.1746 10.8095 15.7076 10.8095 16.3651C10.8095 17.0226 11.3425 17.5555 12 17.5555C12.6575 17.5555 13.1905 17.0226 13.1905 16.3651Z"
        fill="#C8102E"
      />
    </g>
  </svg>
);
{
  /* <svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C20 15.5229 15.5229 20 10 20ZM9.20635 5.23809C9.20635 4.79977 9.56168 4.44444 10 4.44444C10.4383 4.44444 10.7936 4.79977 10.7936 5.23809V10.7936C10.7936 11.232 10.4383 11.5873 10 11.5873C9.56168 11.5873 9.20635 11.232 9.20635 10.7936V5.23809ZM11.1905 14.3651C11.1905 13.7076 10.6575 13.1746 10 13.1746C9.34252 13.1746 8.80952 13.7076 8.80952 14.3651C8.80952 15.0226 9.34252 15.5556 10 15.5556C10.6575 15.5556 11.1905 15.0226 11.1905 14.3651Z"
    fill="#C8102E"
  />
</svg>; */
}

export default ErrorFill;
